export const API_BASE_URL = process.env.NODE_ENV === 'production' 
	? 'https://node-proofreader.herokuapp.com/api'
    : 'http://localhost:8080/api';



// WEBPACK FOOTER //
// ./src/config.js